__turbopack_context__.v({
  "userAvatar": "xmvp4q_userAvatar",
  "userAvatarMedium": "xmvp4q_userAvatarMedium",
  "userAvatarSmall": "xmvp4q_userAvatarSmall",
});
